import { useCallback } from "react";
import formatPrice from "@/core/helpers/formatPrice.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import { imgAvatar } from "@/shared/assets/img";
import { CalendarIcon, NumOneIcon, RubleIcon, TimeIcon } from "@/shared/icons";
import { HeaderTab } from "@/domains/playerMenu/constants/headerTab";
import { userSelector } from "@/domains/account/slice";
import { usePlayerMenuStore } from "@/domains/playerMenu/store";
import { formatMinutes } from "@/domains/account/helpers/formatMinutes";
import AccountExitContainer from "@/domains/account/containers/AccountExitContainer.tsx";
import AccountLogoutContainer from "@/domains/account/containers/AccountLogoutContainer";
import AccountSettingsTrigger from "@/domains/account/components/AccountSettingsTrigger";
import AccountSidebar from "@/domains/account/components/AccountSidebar.tsx";
import AccountSidebarHeader from "@/domains/account/components/AccountSidebarHeader.tsx";
import AccountSocialClub from "@/domains/account/components/AccountSocialClub.tsx";
import AccountStats from "@/domains/account/components/AccountStats.tsx";
import AccountStatsItem from "@/domains/account/components/AccountStatsItem.tsx";
import AccountUser from "@/domains/account/components/AccountUser.tsx";
import AccountVipLabel from "@/domains/account/components/AccountVipLabel.tsx";

export default function AccountSidebarContainer() {
  const { setIsShow, changeHeaderTab } = usePlayerMenuStore();
  const user = useAppSelector(userSelector);

  const openSettingsModalHandler = useCallback(() => {
    changeHeaderTab(HeaderTab.Settings);
    setIsShow(true);
  }, []);

  if (!user) return null;

  return (
    <AccountSidebar>
      <AccountSidebarHeader />
      <AccountUser avatar={imgAvatar} />
      <AccountSocialClub name={user.socialClub} />
      <AccountVipLabel onClick={() => {}} />
      <AccountSettingsTrigger onClick={openSettingsModalHandler} />
      <AccountLogoutContainer />
      <AccountStats>
        <AccountStatsItem
          icon={<RubleIcon size={24} className="mb-2.5 text-accent" />}
          title="Всего денег"
          value={formatPrice(user.charactersTotalBalance)}
        />
        {/* подставить то что с бэка приходит */}
        <AccountStatsItem
          icon={<NumOneIcon size={24} className="mb-2.5 text-accent" />}
          title="Region Coin"
          value={String(user.coins)}
        />
        <AccountStatsItem
          icon={<TimeIcon size={24} className="mb-2.5 text-accent" />}
          title="Всего в игре"
          value={formatMinutes(user.totalPlayingTimeMinutes)}
        />
        <AccountStatsItem
          icon={<CalendarIcon size={24} className="mb-2.5 text-accent" />}
          title="За неделю"
          value={formatMinutes(user.totalPlayingTimeWeekMinutes)}
        />
      </AccountStats>
      <AccountExitContainer />
    </AccountSidebar>
  );
}
